enum MobileSearchTrainersCategories {
  SEARCH = 'trainer-search',
  TRAINER_PROFILE_PUBLIC = 'public-trainer-profile',
}

export default MobileSearchTrainersCategories;
